var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',[_c('GChart',{attrs:{"type":_vm.type,"data":_vm.data,"options":_vm.options,"settings":_vm.settings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }